export default __webpack_public_path__ + "static/media/silver.383e7198.svg";